import React, { useState, useEffect, useContext } from "react";

import axios from "../../api/axios";

import { toast } from "react-toastify";
import PopUpPanel from "../../components/PopUpPanel/PopUpPanel";
import FormField from "../../components/forms/FormField/FormField";
import { CampaignContext } from "../../contexts/CampaignContext";
import HMSTimeField from "../../components/forms/HMSTimeField/HMSTimeField";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";

import { getDefaultTimeZoneListData, convertFormDateTimeTimezoneToUnixTimestamp } from "../../helpers/Dates";

import DateSelect from "../../components/forms/DateSelect/DateSelect";
import SelectUser from "../../components/SelectUser/SelectUser";
import { addStreamRoute } from "../../api/routes";
import { STREAM_STATUS_TYPES } from "../../helpers/Streams";
import { getTimezoneOptions, parseTimezone } from "../../helpers/TimeZones";

const AddStream = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const [showSelectUser, setShowSelectUser] = useState(false);
    const toggleShowSelectUser = (e) => {
        if (e) {
            e.preventDefault();
        }
        setShowSelectUser(!showSelectUser);
    }
    const userSelected = (user) => {
        console.log(user);
        setStreamerHandle(user.name);
        if (user.discord) {
            setStreamDiscord(user.discord);
        } else {
            setStreamDiscord('');
        }
    }

    const [streamerHandle, setStreamerHandle] = useState('');
    const [streamerHandleError, setStreamerHandleError] = useState('');
    const [streamDiscord, setStreamDiscord] = useState('');
    const [streamDiscordError, setStreamDiscordError] = useState('');

    const [streamDate, setStreamDate] = useState(null);
    if (streamDate === null) {
        // We need to set a default date that is 00:00 our time...
        let defaultDate = new Date();
        defaultDate.setHours(0, 0, 0, 0);
        setStreamDate(defaultDate);
    }
    const dateSelected = (id, val) => {
        setStreamDate(val);
    }

    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(0);

    const [tzOptions, setTzOptions] = useState(getTimezoneOptions());

    const reevaluateTimezoneOptions = (selectedTimeZone = null) => {
        const utcUnix_startTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, startTime, selectedTimeZone || timezone);
        const evaluatedOptions = getTimezoneOptions(utcUnix_startTime);
        if (tzOptions !== evaluatedOptions) {
            const currentTimezone = selectedTimeZone || timezone;
            setTzOptions(evaluatedOptions);
            // Settings TzOptions can re-order the list!
            setTimezone(parseTimezone(currentTimezone.value));
        }
    }

    const [timezone, setTimezone] = useState(getDefaultTimeZoneListData(tzOptions));
    const selectTimeZone = (e, id, item) => {
        reevaluateTimezoneOptions(item);
    }

    useEffect(() => {
        reevaluateTimezoneOptions();
    }, [streamDate, startTime]);

    const [isSubmitting, setIsSubmitting] = useState(false);

    const saveStream = (e) => {
        e.preventDefault();

        if(!isSubmitting)
        {
            let formValid = true;
           /* if (streamerHandle === '') {
                setStreamerHandleError('You need to enter your streamer\'s Twitch Handle');
                formValid = false;
            } else {
                setStreamerHandleError('');
            }*/

            if (formValid) {
                let utcUnix_startTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, startTime, timezone);
                let utcUnix_endTime = convertFormDateTimeTimezoneToUnixTimestamp(streamDate, endTime, timezone);

                if(!isSubmitting)
                {
                    // do axios post here
                    setIsSubmitting(true);
                    axios
                    .post(addStreamRoute, { 
                        campaignID:props.campaignId,
                        status:STREAM_STATUS_TYPES.scheduled.dbString,
                        demoMode:true,
                        //twitchHandle:streamerHandle,
                        discord:streamDiscord,
                        startTime:utcUnix_startTime,
                        endTime:utcUnix_endTime,
                        timeZone:timezone.value, 
                        withCredentials:true
                    })
                    .then((response) =>{
                        console.log(response)

                        let oldCampaignData = campaignContext.campaignData
                        oldCampaignData.streams = response.data.campaignData.streams;
                        setIsSubmitting(false);
                        setCampaignContext((oldValues) => {
                            return { ...oldValues, initialising: false, campaignData: oldCampaignData }
                        })

                        toast.success("Stream ("+streamerHandle+") successfully added to campaign");
                        props.closePanelFunc();
                    })
                }
                
            }
        }
    }

    return (
        <>
        {!showSelectUser &&
        <PopUpPanel closePanelFunc={props.closePanelFunc}>
            <div className="form-holder co-popup-content">
                <form id="addstream" className="form">
                    <h2>Add Stream</h2>
                    <div className="label">Schedule Stream</div>
                    <div className="fl-row drop-gap grow">
                        <DateSelect 
                            id="stream_date" 
                            allowPast={false}
                            initialDate={streamDate}
                            selectFunc={dateSelected}
                        />
                    </div>  
                    <div className="fl-row drop-gap shift-up-1-5">
                    <HMSTimeField
                        label="Start"
                        inlineLabel={true}
                        showLabel={false}
                        id="stream_start"
                        value={startTime}
                        setFunc={setStartTime}
                        maxHours={23}
                        showSeconds={false}
                        relativeTime={false}
                        narrow={true}
                        centered={false}
                        showError={false}
                    />
                    <div className="grow-100 j-center">until</div>
                    <HMSTimeField
                        label="Until"
                        inlineLabel={true}
                        showLabel={false}
                        id="stream_end"
                        value={endTime}
                        setFunc={setEndTime}
                        maxHours={23}
                        showSeconds={false}
                        relativeTime={false}
                        narrow={true}
                        centered={false}
                        showError={false}
                    />
                    </div>
                    <FormDropDown
                        id="timezone"
                        label="Timezone"
                        showLabel={false}
                        items={tzOptions}
                        currentIndex={timezone.index}
                        selectFunc={selectTimeZone}
                        className="shift-up-1-5"
                    />
                    <button className={'submit-btn' + (isSubmitting ? ' button-inactive' : ' button-active')} onClick={isSubmitting ? null : saveStream}>
                        {isSubmitting ? "Adding Stream" : "Add Stream"}
                    </button>
                </form>
            </div>
        </PopUpPanel>
        }
        {showSelectUser &&
            <SelectUser closePanelFunc={toggleShowSelectUser} selectUserFunc={userSelected} twitchOnly={true} />
        }
        </>
    )
}

export default AddStream;
